<template>
    <rkm-form
        v-if="model"
        ref="RkmForm"
        show-legend
    >
        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.autorizador.profissional"
                    :request-query-string-params="autocompleteParams.profissional"
                    :search-fields="fields.autocompletes.profissional"
                    :validations="validations.profissional"
                    description="Somente profissional ativo e com CNS informado."
                    label="Profissional"
                    text-field="nome"
                    v-model="model.profissional"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :validations="validations.codigoEmissor"
                    label="Código do emissor"
                    uppercase
                    v-model="model.codigoEmissor"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    :validations="validations.ativo"
                    label="Status"
                    v-model="model.ativo"
                >
                    <rkm-form-select-option :value="true">Ativo</rkm-form-select-option>
                    <rkm-form-select-option :value="false">Inativo</rkm-form-select-option>
                </rkm-form-select>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="6">
                <rkm-form-input
                    :value="profissional.nome"
                    label="Nome"
                    readonly
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    :value="profissional.cns"
                    label="CNS"
                    readonly
                    v-mask="mask.cns"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import {error, mask, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        autocompleteParams() {
            return {
                profissional: {
                    autorizador_id: this.id,
                },
            }
        },
        fields() {
            return {
                autocompletes: {
                    profissional: [
                        {key: 'cidadao.nome', searchable: true},
                        {key: 'cidadao.cns', searchable: true},
                    ],
                },
            }
        },
        profissional() {
            return this.model && this.model.profissional ? this.model.profissional : {}
        },
        validations() {
            return {
                profissional: {required: true},
                codigoEmissor: {required: this.model.ativo, min: 10, max: 10},
                ativo: {required: true},
            }
        },
    },
    created() {
        this.repositories = {
            autorizador: this.getConectaSusRepository('cadastro.autorizador'),
        }
    },
    data: () => ({
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            const request = this.id
                ? this.repositories.autorizador.edit(this.id)
                : this.repositories.autorizador.create()

            request
                .then(response => {
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.setLoading()

                    const request = this.camelObjectKeysToSnakeRecursive({
                        usuarioId: this.model.profissional.id,
                        codigoEmissor: this.model.codigoEmissor,
                        ativo: this.model.ativo,
                    })

                    const save = this.id
                        ? this.repositories.autorizador.update(this.id, request)
                        : this.repositories.autorizador.store(request)

                    save
                        .then(response => {
                            this.$emit('saved', response)
                            this.showSaveNotification()
                        })
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading())
                })
        },
    },
    mixins: [error, mask, repository, stringCase],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>
